module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/11.f5b42da8.jpg";